import axios, { AxiosResponse } from "axios";
import { GetPrinter } from "./utils";
import { ProductDto } from "../../../model/dtos";
const BASE_URL = process.env.API_DOMAIN;

export const Products = {
  Endpoint: "/products",
  GetList: (): Promise<AxiosResponse<ProductDto[]>> => {
    return axios.get(`${BASE_URL}${Products.Endpoint}`);
  },
  Get: (id) => {
    return axios.get(`${BASE_URL}${Products.Endpoint}/${id}`);
  },
  Update: (
    id,
    price,
    name,
    description,
    thumbnail,
    type,
    ingredients,
    stock,
    availability,
    kitchens_ids
  ) => {
    const data = {
      id: id,
      price: price,
      name: name,
      description: description,
      thumbnail: thumbnail,
      type: type,
      ingredients: ingredients,
      stock: stock,
      availability: availability,
      kitchens_ids: kitchens_ids,
    };
    return axios.put(`${BASE_URL}${Products.Endpoint}`, data);
  },
  Create: (
    price,
    name,
    description,
    thumbnail = "",
    type,
    ingredients,
    stock,
    availability = true,
    kitchens_ids
  ) => {
    const data = {
      price: parseFloat(price),
      name: name,
      description: description,
      thumbnail: thumbnail,
      type: Number(type),
      ingredients: ingredients,
      stock: Number(stock),
      availability: availability,
      kitchens_ids: kitchens_ids,
    };
    return axios.post(`${BASE_URL}${Products.Endpoint}`, data);
  },
  Delete: (id) => {
    return axios.delete(`${BASE_URL}${Products.Endpoint}/${id}`);
  },
};

export const Orders = {
  Endpoint: "/orders",
  Create: (OrderProducts, gift) => {
    return axios.post(
      `${BASE_URL}${Orders.Endpoint}/?gift=${
        gift ? 1 : 0
      }&printer=${GetPrinter()}`,
      OrderProducts
    );
  },
  GetList: () => {
    return axios.get(`${BASE_URL}${Orders.Endpoint}`);
  },
  GetListAdmin: () => {
    return axios.get(`${BASE_URL}${Orders.Endpoint}/admin`);
  },
  UpdateStatus: (pun, newStatus) => {
    const data = new FormData();
    data.append("pun", pun);
    data.append("new_status", newStatus);
    return axios.put(`${BASE_URL}${Orders.Endpoint}/`, data);
  },
};

export const Receipts = {
  Endpoint: "/receipts",
  Print: (orderID) => {
    return axios.get(
      `${BASE_URL}${Receipts.Endpoint}/reprint?order_id=${orderID}`
    );
  },
  KitchenPrint: (PUN) => {
    return axios.get(
      `${BASE_URL}${Receipts.Endpoint}/kitchen_reprint?pun=${PUN}`
    );
  },
  GetList: () => {
    return axios.get(`${BASE_URL}${Receipts.Endpoint}/order_manager`);
  },
  UpdateStatus: (pun, newStatus) => {
    const data = new FormData();
    data.append("pun", pun);
    data.append("new_status", newStatus);
    return axios.put(`${BASE_URL}${Receipts.Endpoint}/order_manager`, data);
  },
};

export const Display = {
  Endpoint: "/pun",
  GetList: () => {
    return axios.get(`${BASE_URL}${Display.Endpoint}/`);
  },
};

export const Sponsor = {
  Endpoint: "/sponsors",
  GetList: () => {
    return axios.get(`${BASE_URL}${Sponsor.Endpoint}/`);
  },
};

export const Kitchens = {
  Endpoint: "/kitchens",
  GetTotals: () => {
    return axios.get(`${BASE_URL}${Kitchens.Endpoint}/totals?KitchenID=1`);
  },
  GetTotalsByProduct: (products) => {
    return axios.get(
      `${BASE_URL}${Kitchens.Endpoint}/totals_by_product?KitchenID=1&Products=${products}`
    );
  },
  GetList: () => {
    return axios.get(`${BASE_URL}${Kitchens.Endpoint}/`);
  },
  Update: (kitchenID, kitchenName, printerID) => {
    return axios.put(`${BASE_URL}${Kitchens.Endpoint}/`, {
      iD: kitchenID,
      name: kitchenName,
      printerID: printerID,
    });
  },
  Create: (kitchenName, printerID) => {
    return axios.post(`${BASE_URL}${Kitchens.Endpoint}/`, {
      name: kitchenName,
      printerID: printerID,
    });
  },
  Delete: (id) => {
    return axios.delete(`${BASE_URL}${Kitchens.Endpoint}/${id}`);
  },
};

export const Printers = {
  Endpoint: "/printers",
  GetList: () => {
    return axios.get(`${BASE_URL}${Printers.Endpoint}/`);
  },
};

export const Health = () => {
  return axios.get(`${BASE_URL}/health`);
};

export const PrintSummary = (printerID: number) => {
  return axios.post(`${BASE_URL}/print_summary?printer_id=${printerID}`);
};

export const Resets = {
  Endpoint: "/resets",
  New: () => {
    return axios.post(`${BASE_URL}${Resets.Endpoint}/new`);
  },
};
